import React, { useRef, useEffect, useState } from "react";
import gsap from "gsap";
import { personalDetails } from "../Details";

function Home() {
  const [isDarkMode, setIsDarkMode] = useState(false);

  // Detect dark mode from system preferences
  useEffect(() => {
    const darkMediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
    setIsDarkMode(darkMediaQuery.matches);

    const handleThemeChange = (e) => setIsDarkMode(e.matches);
    darkMediaQuery.addListener(handleThemeChange);
    return () => darkMediaQuery.removeListener(handleThemeChange);
  }, []);

  const { name, tagline, img, InvertImg } = personalDetails;
  const h11 = useRef();
  const h12 = useRef();
  const h13 = useRef();
  const myimageref = useRef();
  useEffect(() => {
    const tl = gsap.timeline();
    tl.from(
      h11.current,
      {
        x: "-100%",
        delay: 0.8,
        opacity: 0,
        duration: 2,
        ease: "Power3.easeOut",
      },
      "<"
    )
      .from(
        h12.current,
        {
          x: "-100%",
          delay: 0.5,
          opacity: 0,
          duration: 2,
          ease: "Power3.easeOut",
        },
        "<"
      )
      .from(
        h13.current,
        {
          x: "-100%",
          delay: 0.1,
          opacity: 0,
          duration: 2,
          ease: "Power3.easeOut",
        },
        "<"
      )
      .from(
        myimageref.current,
        {
          x: "0%",
          opacity: 0.5,
          duration: 2,
          ease: "Power3.easeOut",
        },
        "<"
      );
  }, []);

  return (
    <main className="container mx-auto max-width section md:flex justify-between items-center">
      <div>
        <h1
          ref={h11}
          className="text-2xl text-lightgray-heading dark:text-light-heading md:text-4xl xl:text-5xl xl:leading-tight font-bold"
        >
          Hello,<br></br>My Name is<br></br>
        </h1>
        <h1
          ref={h12}
          className="text-2xl text-gray-heading dark:text-light-content md:text-4xl xl:text-5xl xl:leading-tight font-bold"
        >
          {name}
        </h1>
        <h2
          ref={h13}
          className="text-1g text-lightgray-heading dark:text-light-heading md:text-x1 xl:text-2xl xl:leading-tight font-bold leading-snug"
        >
          {tagline}
        </h2>
      </div>
      <div className="mt-5 md:mt-0" id="HomeClick">
        <img
          ref={myimageref}
          className="w-1/2 md:ml-auto"
          src={isDarkMode ? InvertImg : img}
          alt="Pavan MG"
        />
      </div>
    </main>
  );
}

export default Home;
